export const highlightGridRow = (setHighlightedRow, rowId, api) => {
  const rowIndex = api.getSortedRowIds()?.indexOf(rowId);
  api.scrollToIndexes({ rowIndex });
  setTimeout(() => {
    setHighlightedRow(null);
  }, 800);
}